import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface ContextDialogShellProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  placeholder: string;
  value: string;
  onValueChange: (value: string) => void;
  error: string | null;
  /** A closing remark under the text box; omitted when there is none. */
  note?: string;
  /** The buttons. */
  footer: ReactNode;
}

/** The dialog the consultant explains a decision in (approving or declining a suggestion): a text box, its error, and the buttons. */
export function ContextDialogShell({
  open,
  onOpenChange,
  title,
  description,
  placeholder,
  value,
  onValueChange,
  error,
  note,
  footer,
}: ContextDialogShellProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Textarea
            placeholder={placeholder}
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            rows={10}
            className="resize-none font-mono text-sm"
          />

          {error && <p className="text-sm text-destructive">{error}</p>}

          {note && <p className="text-sm text-muted-foreground">{note}</p>}
        </div>

        <DialogFooter className="gap-2">{footer}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
